module.exports = __webpack_public_path__ + "static/matt-dark-841b6d7141b6e27c7d08505e3f3a1bda.png";